
import styled from "styled-components";
import img_update from "edu_lms_v2/assets/img/dang_cap_nhap.png";

export default function Link({ item, col, index, page }) {
	
	const handleLink = (document) => {
		window.open(document.url, "_blank");
		return;
	};

  return (
    <div key={index} className={col}>
      <article
        className="post bg-sh pr"
        style={{ boxShadow: "5px 5px 10px 1px #ccc" }}
      >
        <BookBlocker>
          <a className="post__thumb cursor"  style={{
	          display: "flex",
	          justifyContent: "center",
	          alignItems: "center",
          }}>
	          <img
		          src={item.is_thumb !== "null" ? item.thumb : img_update}
		          alt=""
		          onClick={() => handleLink(item)}
	          />
          </a>
        </BookBlocker>

        <div
          className="post__content d-flex justify-content-between"
          style={{
            padding: "16px 10px",
            borderTop: "1px solid #FF7707",
            flex: "1",
          }}
        >
	        <Semester
		        title={`${item.worksheet_title}`}
	        >{`${item.worksheet_title}`}</Semester>
	        
	        <ViewLink
		        className="cursor"
		        onClick={() => handleLink(item)}
	        >
		        <i
			        className={`fa fa-eye`}
			        aria-hidden="true"
		        ></i>
	        </ViewLink>
        </div>
      </article>
    </div>
  );
}

const BookBlocker = styled.div`
  .block {
    position: absolute;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.7;
    border-radius: 12px 12px 0 0;
    display: none;
    flex-direction: column;
    justify-content: center;
    .label-active {
      line-height: 20px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      padding: 0 15px;
    }
  }

  &:hover .block {
    display: flex;
  }
`;

const ViewLink = styled.p`
  i {
    padding: 8px 10px;
    border: 1px solid #ff7707;
    border-radius: 5px;
    color: #ff7707;
    &:hover {
      background-color: #ff7707;
      color: #fff;
    }
  }
`;

const Semester = styled.h4`
  padding: 10px 0 0;
  text-transform: none !important;
`;

const Download = styled.a`
  padding-top: 10px;
  i {
    padding: 8px 10px;
    border: 1px solid #ff7707;
    border-radius: 5px;
    color: #ff7707;
    &:hover {
      background-color: #ff7707;
      color: #fff;
    }
  }
`;
